import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";
import DateFilterTable from "../../../components/Content/DateFilterTable";
import moment from "moment";
import { getAlert, getDataWithComp } from "../../../../utils/SamuiUtils";

function Main({
  masterList,
  detailList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  getReport,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(
    localStorage.getItem("itemsPerPageDropdown") || 10
  );
  const [countWaitApprove, setCountWaitApprove] = useState(0);
  const [countApprove, setCountApprove] = useState(0);
  const [countNotApprove, setCountNotApprove] = useState(0);
  const [countCancel, setCountCancel] = useState(0);
  const [searchTerm, setSearchTerm] = useState(
    localStorage.getItem("searchTerm") || ""
  );
  const [filteredItems, setFilteredItems] = useState([]);
  const [startDate, setStartDate] = useState(
    () =>
      localStorage.getItem("startDate") ||
      moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    () =>
      localStorage.getItem("endDate") ||
      moment().endOf("month").format("YYYY-MM-DD")
  );
  const [dateType, setDateType] = useState("1");
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    initialize();
  }, [masterList, detailList]);

  useEffect(() => {
    setCurrentPage(1);
    filterItems();
  }, [searchTerm, dataMasterList, selectedStatus, startDate, endDate]);

  useEffect(() => {
    filterItems();
  }, [startDate, endDate, searchTerm, dataMasterList, selectedStatus]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        const image = await getDataWithComp(
          "Upload_File_List",
          `AND DocCode_ID IN (1) AND Comp_Id = 1`
        );

        // ตรวจสอบข้อมูลจาก image
        if (!image || image.length === 0) {
          console.warn("No files found in Upload_File_List");
        }

        const updatedMasterList = masterList.map((item) => {
          const relatedFiles = image.filter(
            (img) => img["Doc_ID"] === item["Doc_ID"]
          );
          return {
            ...item,
            File_Name:
              relatedFiles.length > 0
                ? relatedFiles.map((file) => file.File_Name)
                : [],
          };
        });

        setDataMasterList(updatedMasterList);
        setFilteredItems(updatedMasterList);

        let statusCounts = {
          รออนุมัติ: 0,
          อนุมัติ: 0,
          ไม่อนุมัติ: 0,
          ยกเลิก: 0,
        };

        updatedMasterList.forEach((data) => {
          if (data.DocStatus_Name) {
            statusCounts[data.DocStatus_Name] =
              (statusCounts[data.DocStatus_Name] || 0) + 1;
          }
        });

        setCountWaitApprove(statusCounts["รออนุมัติ"]);
        setCountApprove(statusCounts["อนุมัติ"]);
        setCountNotApprove(statusCounts["ไม่อนุมัติ"]);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const filterItems = () => {
    let filtered = dataMasterList;

    const start = moment(startDate, "YYYY-MM-DD");
    const end = moment(endDate, "YYYY-MM-DD");

    filtered = filtered.filter((item) => {
      const itemDate =
        dateType === "1"
          ? moment(item.Doc_Date, "YYYY-MM-DD")
          : moment(item.Doc_DueDate, "YYYY-MM-DD");
      return itemDate.isBetween(start, end, null, "[]");
    });

    if (searchTerm.trim() !== "") {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) => {
          if (typeof value === "string") {
            return value.toLowerCase().includes(lowercasedSearchTerm);
          } else if (typeof value === "number") {
            return value.toString().includes(searchTerm);
          }
          return false;
        })
      );
    }

    // ฟิลเตอร์ตามสถานะที่เลือก
    if (selectedStatus) {
      filtered = filtered.filter((item) => {
        if (statusColours.some((status) => status.DocSetStaus_Name === selectedStatus)) {
          return item.DocStatus_Name === selectedStatus;
        }
        return false;
      });
    }

    setFilteredItems(filtered);
  };

  // เมื่อคลิกสถานะ
  const handleStatusClick = (statusName) => {
    setSelectedStatus((prev) => (prev === statusName ? null : statusName));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "ขายสินค้า", url: "/quotation" },
            { name: name, url: "/quotation" },
          ]}
        />
      </div>
      <div
        className="row hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="col-1">
          <center>
            <b>สถานะเอกสาร</b>
          </center>
          <br />
          {statusColours.map((statusObj, index) => {
            const { DocSetStaus_Name, DocSetColour } = statusObj;
            let count;

            switch (DocSetStaus_Name) {
              case "รออนุมัติ":
                count = countWaitApprove;
                break;
              case "อนุมัติ":
                count = countApprove;
                break;
              case "ไม่อนุมัติ":
                count = countNotApprove;
                break;
              case "ยกเลิก":
                count = countCancel;
                break;
              default:
                count = 0;
            }

            return (
              <div key={index} className="col-12 mb-3" onClick={() => handleStatusClick(DocSetStaus_Name)} style={{ cursor: "pointer" }}>
                <div
                  className="card text-center"
                  style={{
                    backgroundColor: DocSetColour,
                    boxShadow: selectedStatus === DocSetStaus_Name ? "0 0 15px rgba(0,0,0,0.5)" : "none",
                    border: selectedStatus === DocSetStaus_Name ? "2px solid #333" : "none",
                    transform: selectedStatus === DocSetStaus_Name ? "scale(1.05)" : "scale(1)",
                    transition: "transform 0.15s, box-shadow 0.15s, border 0.15s",
                  }}
                >
                  <div className="card-body d-flex flex-column align-items-center text-white">
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "20px", textAlign: "center" }}>{count}</b>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <b style={{ fontSize: "16px", textAlign: "center" }}>
                          {DocSetStaus_Name}
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-11">
          <div
            className="p-3 rounded-3 my-2 shadow-lg"
            style={{ backgroundColor: "#fff" }}
          >
            <div className="row mb-2">
              <div className="col-3">
                <div className="navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="ค้นหาเอกสาร..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        localStorage.setItem("searchTerm", e.target.value);
                      }}
                    />
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-7 d-flex">
                <DateFilterTable
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  onClick={onPageInsert}
                  className="btn btn-warning text-white ms-2"
                  type="button"
                >
                  สร้าง{name} <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <DataTable
            currentItems={currentItems}
            onRowSelected={onRowSelected}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            dataMasterList={filteredItems}
            setDataMasterList={setFilteredItems}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            fieldMappings={{
              no: "Doc_No",
              typeName: "DocType_Name",
              docSoNo: "Doc_SO_No",
              statusName: "DocStatus_Name",
              statusColor: "DocStatus_Colour",
              printedStatus: 'Printed_Status',
              statusPaidTypeName: "DocStatusPaid_Type_Name",
              statusPaidTypeColour: "DocStatusPaidType_Colour",
              date: "Doc_Date",
              arCode: "AR_Code",
              arName: "AR_Name",
              dueDate: "Doc_DueDate",
              netTotal: "NetTotal",
              createdBy: "Created_By_Name",
              updatedBy: "Update_By_Name",
              File_Name: "File_Name",
            }}
            getReport={(docNo) => {
              (async () => {
                try {
                  await getReport("qt", docNo);
                } catch (e) {
                  console.error(e);
                } finally {
                  await initialize();
                }
              })();
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Main;
